module.exports = __webpack_public_path__ + "img/Moonbase_upload.7de7dd92.gif";